"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AuthBox_1 = require("./AuthBox");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return AuthBox_1.default; } });
